export default "__VITE_ASSET__CzFtRbuv__"